import CryptoJS from "crypto-js";

export const encryptJSON = (jsonObject) => {
  try {
    // Convert JSON object to string
    const jsonString = JSON.stringify(jsonObject);

    // Encrypt using AES with PKCS7 (equivalent to PKCS5) padding
    const encryptedData = CryptoJS.AES.encrypt(
      jsonString,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_1),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_2),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding (compatible with PKCS5)
      }
    );

    // Return the encrypted data as a base64-encoded string
    return encryptedData.toString();
  } catch (error) {
    console.error("Encryption error:", error);
    return null;
  }
};
export const decryptJSON = (encryptedData) => {
  try {
    // Decrypt using AES with PKCS7 (equivalent to PKCS5) padding
    const decryptedBytes = CryptoJS.AES.decrypt(
      encryptedData,
      CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_1),
      {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_API_MIDDLEWARE_KEY_2),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7, // Use PKCS7 padding (compatible with PKCS5)
      }
    );

    // Convert decrypted bytes to a UTF-8 string
    const decryptedString = decryptedBytes.toString(CryptoJS.enc.Utf8);

    return decryptedString.toString();
  } catch (error) {
    console.error("Decryption error:", error);
    return null;
  }
};
export const fetchAPI = async (url, requestData, headers = {}) => {
  try {
    const encryptedBody = encryptJSON(requestData);
    if (!encryptedBody) {
      throw new Error("Failed to encrypt request");
    }

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...headers,
      },
      body: encryptedBody,
    });

    const encryptedResponseData = await response.text();

    if (!response.ok) {
      throw new Error(
        `HTTP error! Status: ${response.status}${
          encryptedResponseData ? ` — ${encryptedResponseData.slice(0, 120)}` : ""
        }`
      );
    }

    if (!encryptedResponseData?.trim()) {
      throw new Error("Empty response from server");
    }

    const decryptedData = decryptJSON(encryptedResponseData);
    if (decryptedData == null || String(decryptedData).trim() === "") {
      throw new Error("Unable to decrypt server response");
    }

    return decryptedData;
  } catch (error) {
    console.error("Error fetching API:", error);
    throw error;
  }
};
